module.exports = __webpack_public_path__ + "img/close.58a0bf2c.png";